import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface ProfileLinkProps {
  username?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Links to a user's profile, falling back to a plain span when there is no
 * username — deleted accounts leave dangling references on comments and makes,
 * and a link to /undefined is worse than no link.
 */
export default function ProfileLink({
  username,
  className,
  children,
}: ProfileLinkProps) {
  if (!username) return <span className={className}>{children}</span>;

  return (
    <Link
      to={`/${username}`}
      className={`${className ?? ''} rounded-sm hover:underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`}
    >
      {children}
    </Link>
  );
}
